import * as THREE from 'three';
// @ts-ignore
import organicVert from '../Shaders/organicBackground/vertex.glsl';
// @ts-ignore
import organicFrag from '../Shaders/organicBackground/fragment.glsl';
function hexToVec3(hex) {
    const c = new THREE.Color(hex);
    return new THREE.Vector3(c.r, c.g, c.b);
}
const MAX_BLOBS = 6;
export default class OrganicBackground {
    constructor(application, config) {
        this.blobPositions = [];
        this.blobPhases = [];
        this.application = application;
        this.config = config;
        for (let i = 0; i < MAX_BLOBS; i++) {
            this.blobPositions.push({
                x: 0.2 + 0.6 * Math.random(),
                y: 0.2 + 0.6 * Math.random(),
            });
            this.blobPhases.push(Math.PI * 2 * Math.random());
        }
        const blobUniforms = {};
        for (let i = 0; i < MAX_BLOBS; i++) {
            blobUniforms[`u_blob${i}`] = {
                value: new THREE.Vector2(this.blobPositions[i].x, this.blobPositions[i].y),
            };
        }
        this.uniforms = Object.assign({ u_resolution: { value: new THREE.Vector2(1, 1) }, u_baseColor: { value: hexToVec3(config.baseColor) }, u_blobColor: { value: hexToVec3(config.blobColor) }, u_blobRadius: { value: config.blobRadius }, u_blobSoftness: { value: config.blobSoftness }, u_opacity: { value: config.opacity }, u_blobCount: { value: config.blobCount } }, blobUniforms);
        const material = new THREE.ShaderMaterial({
            vertexShader: organicVert,
            fragmentShader: organicFrag,
            uniforms: this.uniforms,
            depthTest: true,
            depthWrite: true,
        });
        this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(10000, 10000), material);
        this.mesh.renderOrder = -1000;
        this.mesh.frustumCulled = false;
        this.mesh.castShadow = false;
        this.mesh.receiveShadow = false;
        this.application.scene.add(this.mesh);
    }
    update() {
        const { mouse, sizes } = this.application;
        const t = this.application.time.current * 0.001;
        const speed = this.config.driftSpeed * 0.0008;
        const margin = 0.12;
        const mouseUv = {
            x: mouse.x / sizes.width,
            y: 1.0 - mouse.y / sizes.height,
        };
        for (let i = 0; i < this.config.blobCount; i++) {
            const p = this.blobPositions[i];
            const phase = this.blobPhases[i];
            p.x += Math.sin(t + phase) * speed;
            p.y += Math.cos(t * 0.7 + phase * 1.3) * speed;
            const dx = p.x - mouseUv.x;
            const dy = p.y - mouseUv.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < this.config.mouseRepelRadius && dist > 0.0001) {
                const push = (this.config.mouseRepelStrength * 0.002 * (1 - dist / this.config.mouseRepelRadius)) / dist;
                p.x += dx * push;
                p.y += dy * push;
            }
            p.x = THREE.MathUtils.clamp(p.x, margin, 1 - margin);
            p.y = THREE.MathUtils.clamp(p.y, margin, 1 - margin);
            this.uniforms[`u_blob${i}`].value.set(p.x, p.y);
        }
        const dpr = Math.min(sizes.pixelRatio, 2);
        this.uniforms.u_resolution.value.set(sizes.width * dpr, sizes.height * dpr);
        this.mesh.position.copy(this.application.camera.instance.position);
        this.mesh.quaternion.copy(this.application.camera.instance.quaternion);
    }
}
